export const packagingLabel = (id: string, name: string | undefined) => {
  if (name) {
    return `${id} - ${name}`;
  }
  return id;
};
